<template>
  <div>
    <div class="title-container">
      <h3>Afwerking</h3>
      <close-button
        class="close-sub-treatment"
        @click="subMenu = []"
        v-if="subMenu.length"
      ></close-button>
    </div>

    <ul id="treatments-menu" class="myclearfix" v-show="subMenu.length === 0">
      <li v-for="option in specs.treatments" :key="option">
        <button
          class="option-button"
          @click="selectTreatment(option)"
          :class="{
            active:
              treatment === option ||
              (specs[option] && specs[option].indexOf(treatment) > -1)
          }"
        >
          {{ option }}
        </button>
      </li>
    </ul>
    <ul class="sub-menu">
      <li v-for="option in subMenu" :key="option">
        <div class="dual-button-remove">
          <button
            class="option-button"
            :class="{ active: treatment === option }"
            @click="selectTreatment(option)"
          >
            {{ option }}
          </button>
          <button @click="removeTreatment" class="remove-btn-white">
            <span></span>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: ['specs', 'treatment'],
  data() {
    return {
      subMenu: []
    }
  },
  methods: {
    selectTreatment(treatment) {
      if (treatment in this.specs) {
        this.subMenu = this.specs[treatment]
      } else if (this.treatment === treatment) {
        this.$emit('setTreatment', '')
        this.subMenu = []
      } else {
        this.$emit('setTreatment', treatment)
        this.subMenu = []
      }
    },
    removeTreatment() {
      this.subMenu = []
      this.$emit('setTreatment', '')
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0 -8px;
}
#treatments-menu {
  li {
    float: left;
    width: 33.3%;
    height: 26px;
    margin-bottom: 7px;

    &:nth-child(3n + 2) {
      text-align: center;
    }

    &:nth-child(3n + 3) {
      text-align: right;
    }
  }
}

.sub-menu li {
  padding-bottom: 10px;
}

.dual-button-remove {
  position: relative;

  button:first-child {
    padding-right: 16px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  button:nth-child(2) {
    position: absolute;
    right: 6px;
    top: 8px;
  }
}

.close-sub-treatment {
  position: absolute;
  top: 2px;
  right: 0;
}
</style>
